import { StylesProps } from 'types/common';

export const styles: StylesProps = {
  gridItem: {
    display: 'flex',
    gap: '7px',
    alignItems: 'center',
  },
};
